// extracted by mini-css-extract-plugin
export var csatScore = "_lp-5";
export var header = "_lp-1";
export var panelWrapper = "_lp-2";
export var postPreview = "_lp-3";
export var rightContent = "_lp-0";
export var wrappingText = "_lp-4";